/**
 * Listeners and handlers for help popovers on the schedule component.
 */
class ScheduleHelp {
  constructor() {
    this.popovers = [
      'schedule-notification-info',
    ]
  }

  /**
   * Register the handler for when a popover opens.
   */
  listenToOpen() {
    $('#ID_SCHEDULE_MODAL .config-popover-info').on(
      'show.bs.popover',
      this.onOpen.bind(this)
    )
  }

  /**
   * Initiate a popover with id `id` and content id `id`-html
   */
  popoverInfo(id) {
    $(`#${id}`).popover({
      content: $(`#${id}-html`).html(),
      html: true,
    })
  }

  /**
   * Close the other popovers when one is opened.
   */
  onOpen(event) {
    const popoversToClose = this.popovers.filter(
      id => $(event.target).attr('id') !== id
    )
    popoversToClose.forEach(id => $(`#${id}`).popover('hide'))
  }

  /**
   * Initialize the configuration modal help popovers.
   */
  onLoad() {
    this.popovers.forEach(id => this.popoverInfo(id))
    this.listenToOpen()
  }
}

export { ScheduleHelp }
